import {useTheme} from 'styled-components';
import {components} from 'react-select';
import type {DropdownIndicatorProps, GroupBase} from 'react-select';
import {SelectOptionType} from '@guestapp/sdk';
import {CustomIcon} from '@guestapp/ui';
import {CustomIconContainer, DisplayIcon, StyledCustomIcon} from './styled';

const DropdownIndicator = <T, V, L>(
  props: DropdownIndicatorProps<
    SelectOptionType<T, V, L>,
    false,
    GroupBase<SelectOptionType<T, V, L>>
  >,
) => {
  const theme = useTheme();
  const selectProps = props?.selectProps;
  const customIndicator =
    selectProps?.isMenuOpen && selectProps?.indicatorOpenState
      ? selectProps?.indicatorOpenState
      : selectProps?.indicator;
  const color = props.isFocused ? theme.colors.branding.primary : '#6B6B95';

  return (
    <>
      {!selectProps.isLoading ? (
        <components.DropdownIndicator {...props}>
          {props?.selectProps?.indicator && customIndicator ? (
            <CustomIconContainer
              $shouldRotate={Boolean(
                selectProps.isMenuOpen && !selectProps?.indicatorOpenState,
              )}
            >
              <CustomIcon
                color="#6B6B95"
                name={customIndicator}
                size={selectProps?.indicatorSize}
              />
            </CustomIconContainer>
          ) : (
            <DisplayIcon $shouldRotate={Boolean(selectProps.isMenuOpen)}>
              <StyledCustomIcon color={color} name="arrow" size="18px" />
            </DisplayIcon>
          )}
        </components.DropdownIndicator>
      ) : null}
    </>
  );
};

export {DropdownIndicator};
